// extracted by mini-css-extract-plugin
module.exports = {"bannerHome":"banner-module--bannerHome--3FXwN","bannerHomeImg":"banner-module--bannerHomeImg--22tQK"};